namespace $ {

	$mol_style_define( $bog_wikilive_table_view, {

		flex: {
			direction: 'column',
		},

		Header: {
			flex: {
				wrap: 'wrap',
			},
			gap: '.5rem',
			padding: {
				top: '.5rem',
				bottom: '.5rem',
				left: 0,
				right: 0,
			},
		},

		Title_edit: {
			font: {
				weight: 600,
			},
		},

		Grid: {
			flex: {
				shrink: 0,
			},
		},

	} )

}
